import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ProjectsService } from '@/app/services/projects/projects.service';

@Component({
  selector: 'app-confirmation-dialogue',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './confirmation-dialogue.component.html',
  styleUrl: './confirmation-dialogue.component.css',
})
export class ConfirmationDialogueComponent {
  eoi_id: any;
  closeEoidata: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectsService: ProjectsService,
    private dialogRef: MatDialogRef<ConfirmationDialogueComponent> // Inject dialog reference
  ) {
    this.closeEoidata = data;
    this.eoi_id = data.eoi_id;
  }
  onConfirm() {
    this.closeEoiSubmissions(this.eoi_id);
  }
  onClose() {
    this.dialogRef.close(); // Properly close the dialog
  }
  closeEoiSubmissions(eoi_id: any) {
    return this.projectsService.closeEOI(eoi_id).subscribe({
      next: () => {
        // Perform any additional actions
        this.onClose(); // Close the dialog after successful operation
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }
}
